import { EVENTS as BaseEvents } from '@/app/shared/utils/constants';
import { apiConstants } from './api-constants';
let code = apiConstants.code;

export const EVENTS = {
    SELECT_FEATURE: BaseEvents.SELECT_FEATURE,
    UNSELECT_FEATURE: BaseEvents.UNSELECT_FEATURE,
    UPDATE_FEATURE: BaseEvents.UPDATE_FEATURE,
    INITIALIZE_NEW_FEATURE: BaseEvents.INITIALIZE_NEW_FEATURE,
    FINISHED_NEW_FEATURE: BaseEvents.FINISHED_NEW_FEATURE,
    SHOW_MODAL_NEW_FEATURE: `${code}:new-feature-show-modal`,
    SHOW_MODAL_DETAIL_FEATURE: `${code}:detail-feature-show-modal`,
    CLOSE_MODAL_DETAIL_FEATURE: `${code}:detail-feature-close-modal`,
    SHOW_MODAL_EDIT_FEATURE: `${code}:edit-feature-show-modal`,
    CLOSE_MODAL_EDIT_FEATURE: `${code}:edit-feature-close-modal`,

    SHOW_ADVANCED_SEARCH: `${code}:cemetery-advanced-search-show-modal`,
    CLOSE_ADVANCED_SEARCH: `${code}:cemetery-advanced-search-close-modal`,

    SELECT_FEATURE_CEMETERY: `${code}:cemetery-select-feature`,

    // CEMETERY
    SHOW_MODAL_READ_CEMETERY: `${code}:cemetery-read-show-modal`,
    CLOSE_MODAL_READ_CEMETERY: `${code}:cemetery-read-close-modal`,
    CLOSED_MODAL_READ_CEMETERY: `${code}:cemetery-read-closed-modal`,
    SHOW_MODAL_DETAIL_CEMETERY: `${code}:cemetery-detail-show-modal`,
    CLOSE_MODAL_DETAIL_CEMETERY: `${code}:cemetery-detail-close-modal`,
    CLOSED_MODAL_DETAIL_CEMETERY: `${code}:cemetery-detail-closed-modal`,

    // SECTOR
    SHOW_MODAL_SECTORS: `${code}:sectors-show-modal`,
    CLOSE_MODAL_SECTORS: `${code}:sectors-close-modal`,
    CLOSED_MODAL_SECTORS: `${code}:sectors-closed-modal`,
    SHOW_MODAL_DETAIL_SECTOR: `${code}:sector-detail-show-modal`,
    CLOSE_MODAL_DETAIL_SECTOR: `${code}:sector-detail-close-modal`,
    CLOSED_MODAL_DETAIL_SECTOR: `${code}:sector-detail-closed-modal`,

    // OCCUPATION
    SHOW_MODAL_READ_OCCUPATION: `${code}:occupation-read-show-modal`,
    CLOSE_MODAL_READ_OCCUPATION: `${code}:occupation-read-close-modal`,
    CLOSED_MODAL_READ_OCCUPATION: `${code}:occupation-read-closed-modal`,
    SHOW_MODAL_DETAIL_OCCUPATION: `${code}:occupation-detail-show-modal`,
    CLOSE_MODAL_DETAIL_OCCUPATION: `${code}:occupation-detail-close-modal`,
    CLOSED_MODAL_DETAIL_OCCUPATION: `${code}:occupation-detail-closed-modal`,

    // INTERMENTS
    SHOW_MODAL_DETAIL_INTERMENT: `${code}:interment-detail-show-modal`,
    CLOSE_MODAL_DETAIL_INTERMENT: `${code}:interment-detail-close-modal`,
    CLOSED_MODAL_DETAIL_INTERMENT: `${code}:interment-detail-closed-modal`,

    // DEED OWNER
    SHOW_MODAL_DETAIL_DEED_OWNER: `${code}:deed-owner-detail-show-modal`,
    CLOSE_MODAL_DETAIL_DEED_OWNER: `${code}:deed-owner-detail-close-modal`,
    CLOSED_MODAL_DETAIL_DEED_OWNER: `${code}:deed-owner-detail-closed-modal`,

    // DEED OWNER HOLDER
    SHOW_MODAL_DETAIL_DEED_OWNER_HOLDER: `${code}:deed-owner-holder-detail-show-modal`,
    CLOSE_MODAL_DETAIL_DEED_OWNER_HOLDER: `${code}:deed-owner-holder-detail-close-modal`,
    CLOSED_MODAL_DETAIL_DEED_OWNER_HOLDER: `${code}:deed-owner-holder-detail-closed-modal`,

    // DEED OWNER APPLICANT
    SHOW_MODAL_DETAIL_DEED_OWNER_APPLICANT: `${code}:deed-owner-applicant-detail-show-modal`,
    CLOSE_MODAL_DETAIL_DEED_OWNER_APPLICANT: `${code}:deed-owner-applicant-detail-close-modal`,
    CLOSED_MODAL_DETAIL_DEED_OWNER_APPLICANT: `${code}:deed-owner-applicant-detail-closed-modal`,

    // ENTITY
    SHOW_MODAL_DETAIL_ENTITY: `${code}:entity-detail-show-modal`,
    CLOSE_MODAL_DETAIL_ENTITY: `${code}:entity-detail-close-modal`,
    CLOSED_MODAL_DETAIL_ENTITY: `${code}:entity-detail-closed-modal`,

    // ACTIONS
    CREATED: 'created',
    CREATED_VIRTUAL: 'created_virtual',
    UPDATED: 'updated',
    UPDATED_VIRTUAL: 'updated_virtual',
    DELETED: 'deleted',
    DELETED_VIRTUAL: 'deleted_virtual',
    SAVED: 'saved',
};